export class Certificate {
    certificateName: string;
    status: boolean;
    id: number;
}